/**
 * Inset an INLINE grid keeps at its outer edges on desktop (see useIsInlineDesktop).
 *
 * The grid clips its content (overflow-hidden), so the inset must hold everything
 * that edge controls paint outside their box: the count badge on the filter and
 * sort buttons (-top-1 -right-1, 0.25rem), the 4px focus ring of the quick search
 * and the icon button focus outline (2px with a 2px offset). It is a rem value,
 * so it grows with the root font size together with the badge offset.
 */
export const INLINE_EDGE_INSET = '0.25rem';
